module.exports = __webpack_public_path__ + "img/25.ac656278.jpg";